import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="px-4 md:px-6 pb-4">
      <div className="relative rounded-3xl bg-secondary-100 overflow-hidden">
        <div className="px-6 md:px-12 lg:px-16 pt-16 pb-8">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8">
            <div className="md:col-span-4">
              <div className="flex items-center gap-3">
                <span className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-500 text-background-50 font-label font-semibold text-sm">
                  GH
                </span>
                <span className="font-heading text-foreground-950 text-3xl">
                  GH Corporation
                </span>
              </div>
              <p className="mt-6 text-foreground-700 text-[14px] leading-relaxed max-w-xs">
                Your trusted Korea-side sourcing and export partner. Access to 125+ Korean beauty brands, multi-brand consolidation, and FCL, LCL and air freight worldwide.
              </p>
            </div>

            <div className="md:col-span-2">
              <h4 className="font-label text-[11px] tracking-[0.22em] uppercase text-foreground-800">
                <Link to="/about" className="cursor-pointer hover:text-accent-600 transition-colors">
                  Explore
                </Link>
              </h4>
              <ul className="mt-5 space-y-3">
                {[
                  { l: "About", to: "/about" },
                  { l: "Brands", to: "/brands" },
                  { l: "Services", to: "/services" },
                  { l: "Markets", to: "/markets" },
                  { l: "Contact", to: "/contact" },
                ].map((it) => (
                  <li key={it.l}>
                    <Link
                      to={it.to}
                      className="text-foreground-600 hover:text-accent-600 text-sm cursor-pointer transition-colors"
                    >
                      {it.l}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div className="md:col-span-3">
              <h4 className="font-label text-[11px] tracking-[0.22em] uppercase text-foreground-800">
                <Link to="/contact" className="cursor-pointer hover:text-accent-600 transition-colors">
                  Contact
                </Link>
              </h4>
              <ul className="mt-5 space-y-3 text-foreground-700 text-sm">
                <li className="flex items-start gap-3">
                  <i className="ri-user-line mt-0.5 text-accent-500" />
                  <span>Kihwan Kwon</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-mail-line mt-0.5 text-accent-500" />
                  <a href="mailto:kwonkhkorea@gmail.com" rel="nofollow" className="cursor-pointer hover:text-accent-600 transition-colors">
                    kwonkhkorea@gmail.com
                  </a>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-whatsapp-line mt-0.5 text-accent-500" />
                  <span>+82-10-4270-0614</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-smartphone-line mt-0.5 text-accent-500" />
                  <span>KakaoTalk · WhatsApp · Viber · Telegram available</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-map-pin-line mt-0.5 text-accent-500" />
                  <span>114 Yeomjeon-ro, Michuhol-gu, Incheon, Republic of Korea</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-time-line mt-0.5 text-accent-500" />
                  <span>Mon–Fri · 09:00–18:00 KST</span>
                </li>
              </ul>
            </div>

            <div className="md:col-span-3">
              <h4 className="font-label text-[11px] tracking-[0.22em] uppercase text-foreground-800">
                Export Markets
              </h4>
              <div className="mt-5 flex flex-wrap gap-2">
                {[
                  "Latin America",
                  "USA",
                  "Canada",
                  "UAE",
                  "Saudi Arabia",
                  "EU",
                  "Singapore",
                  "Mongolia",
                  "HongKong",
                ].map((c) => (
                  <span
                    key={c}
                    className="px-3 py-1.5 rounded-full bg-background-50 text-secondary-700 border border-secondary-200 text-xs"
                  >
                    {c}
                  </span>
                ))}
              </div>
              <p className="mt-4 text-foreground-500 text-[12px] leading-relaxed">
                Current and target export markets. Contact us about your destination.
              </p>
            </div>
          </div>

          <div className="mt-16 pt-6 border-t border-secondary-200 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
            <p className="text-foreground-500 text-[12px]">
              © {new Date().getFullYear()} GH Corporation. All rights reserved.
            </p>
            <p className="text-foreground-500 text-[12px]">
              Korean Cosmetics Export · Global Logistics · K-Beauty Wholesale
            </p>
          </div>
        </div>

        <div className="px-6 md:px-12 lg:px-16 pb-2 select-none pointer-events-none">
          <div className="font-heading font-light text-secondary-200/50 text-[20vw] leading-[0.85] tracking-tight">
            GH
          </div>
        </div>
      </div>
    </footer>
  );
}